import axios from "axios"

// axios.defaults.baseURL = 'http://localhost:8001/'
axios.defaults.baseURL = 'https://api.sv-quiz.fr/'